import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsvConsultationChecklistLineModel } from '../../../../../models/aggregates/asv/asv-consultation-checklist-line.model';
import {BaseApiTemplateService, Core2Config} from '../../api-services';

@Injectable({
  providedIn: 'root'
})
export class AsvConsultationChecklistLineService extends BaseApiTemplateService<AsvConsultationChecklistLineModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ASV_PREFIX + 'consultation-checklist-line';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'consultation-checklist-line/' + Core2Config.BACKOFFICE_EP_SUFFIX; 
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'consultation-checklist-line/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.httpClient = http;
      }
}
